<ng-container *transloco="let t;">
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card">
        <app-loader [loading]="loading"></app-loader>
        <div *ngIf="loading !== true">
          <div class="card-header p-grid">
            <div class="p-col-8">
              <h1>{{ t('common.labels.exercises') }}</h1>
            </div>
            <div class="p-col-4 p-text-right">
              <button withRight="admin.exercise.list" pButton (click)="onReload()" type="button" icon="pi pi-refresh"
                class="p-button-secondary p-button-outlined p-mb-2" aria-label="{{ t('common.labels.reload_list') }}"
                pTooltip="{{ t('common.labels.reload_list') }}" tooltipPosition="left"></button>
              <button withRight="admin.exercise.create" pButton (click)="onNew()" type="button" icon="pi pi-plus"
                label="{{ t('common.labels.new') }}" class="p-button-success p-ml-2 p-mb-2"></button>
            </div>
          </div>

          <p-messages [(value)]="messages"></p-messages>

          <p-table
            [loading]="loading"
            [value]="exercises"
            [paginator]="true"
            [rows]="20"
            stateStorage="local"
            stateKey="exercise-list"
            [rowsPerPageOptions]="rowsPerPage"
            [showCurrentPageReport]="true"
            [currentPageReportTemplate]="t('common.labels.current_page_report')"
          >
            <ng-template pTemplate="header">
              <tr>
                <th pSortableColumn="name">{{ t('common.labels.name') }}
                  <p-sortIcon field="name"></p-sortIcon>
                </th>
                <th pSortableColumn="language">{{ t('common.labels.language') }}
                  <p-sortIcon field="language"></p-sortIcon>
                </th>
                <th pSortableColumn="for_single">{{ t('common.labels.for_single_procedures') }}
                  <p-sortIcon field="for_single"></p-sortIcon>
                </th>
                <th pSortableColumn="for_group">{{ t('common.labels.for_group_procedures') }}
                  <p-sortIcon field="for_group"></p-sortIcon>
                </th>
              </tr>
              <tr class="filter">
                <th>
                  <p-columnFilter type="text" field="name" [matchMode]="'contains'"></p-columnFilter>
                </th>
                <th></th>
                <th></th>
                <th></th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-exercise>
              <tr (click)="onOpen(exercise)" (keyup.enter)="onOpen(exercise)" hoverOnRight="admin.exercise.show"
                tabindex="0">
                <td><span role="link">{{ exercise.name }} <i *ngIf="exercise.status === 'inactive'">({{ t('common.deactivated') }})</i></span></td>
                <td>{{ t(exercise.getLanguageName()) }}</td>
                <td><fa-icon [icon]="(exercise.for_single === true) ? faCheck : faBan"></fa-icon></td>
                <td><fa-icon [icon]="(exercise.for_group === true) ? faCheck : faBan"></fa-icon></td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td class="no-data">{{ t('common.labels.no_data') }}</td>
              </tr>
            </ng-template>
          </p-table>

          <div class="p-mt-4">
            <app-form-control [cid]="'show_inactive'" [control]="form.get('show_inactive')" [type]="'checkbox'" [label]="t('exercise_list.show_inactive')"></app-form-control>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
